import { render } from "./Tag.vue?vue&type=template&id=e8ca5cca&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"

import "./Tag.vue?vue&type=style&index=0&id=e8ca5cca&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e8ca5cca"

export default script